export default __webpack_public_path__ + "static/media/89.0504d7ff.png";